import { Neo4jClient } from "../alias";

export type Neo4jConfig = {
  uri: string;
  user: string;
  password: string;
};

export const neo4jClientFactory = ({ uri, user, password }: Neo4jConfig) =>
  new Neo4jClient(uri, user, password);
